$(document).ready(function(){
    //Configuración general datatables:
    $.extend(true, $.fn.dataTable.defaults, {
        dom: "Blfrtip",
        buttons: [],
        "language" : {
            "url": "/plugins/datatables-translations/datatables.2.1.6.i18n.es-ES.json"
        },
        responsive: true,
        stateSave: false,    //Guarda página al refrescar.
        initComplete: function(){
            //Búsqueda automática al clicar sobre el td.filtro:
            var api = this.api();
            api.$('td.filtro').click(function(){
                api.search(this.innerHTML).draw();
            });

            this.api().columns().every(function(){
                var column = this;
                var input = document.createElement("input");
            });
        }
    });

    $('.dTable').DataTable({
        stateSave: true,    //Guarda página al refrescar.
    });

    //Tabla Rates:
    if($('#tblRatesPublic').length > 0){
        let tokenDT = $('meta[name="csrf-token"]').attr('content');
        let all = $('#all').val();
        let method = all? '/all':'';

        //Filters:

        // Load data from localstorage
        let jsonData = JSON.parse(localStorage.getItem('DataTables_tblRatesPublic_'+window.location.pathname));

        let modeMovil = $('#tblRatesPublic.collapsed').length > 0;

        const addSearchBox = () => {
            let rowSearch = $('#tblRatesPublic thead tr').clone(true);
            rowSearch.attr('id', 'tblRatesPublicRowSearch');
            rowSearch.appendTo('#tblRatesPublic thead');
            
            $('#tblRatesPublicRowSearch th').each(function(index){
                let title = $(this).text();
                if(index >= 7) {
                    $(this).html('');
                }else{
                    // Check field on json of localstorage
                    let value = jsonData && jsonData.columns[index]?.search?.search ? jsonData.columns[index].search.search : '';
                    let htmlRaw = `<input type="text" class="DTsearch" placeholder="${'Buscar '+title}" value="${value}" />`
                    $(this).html(htmlRaw);
    
                    // $(this).html('<input type="text" class="DTsearch" placeholder="'+txtBuscar+' '+title+'"/>');
                }
                $('input', this).on('keyup change', function(){
                    if(tableRatesPublic.column(index).search() !== this.value){
                        tableRatesPublic
                            .column(index)
                            .search(this.value)
                            .draw();
                    }
                });
            });
        }

        let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        let typePagination = vw > 768 ? 'simple_numbers' : 'simple';

        const descripcionArticuloRender = function (data, _, full) {
            // href="${full.link}" target="_blank"
            return `<span>
                        ${data}
                        <i class="fa fa-chevron-down ml-2 iconChange"></i>
                    </span>`;
        };


        const availabilityRender = function (data, type, full, meta) {
            return `<i class="fa fa-circle type-${data}"></i>`;
        };

        const familyArticuloRender = function (data, type, full, meta) {
            // let maxTextLength = vw > 768 ? 25 : 50;
            // let truncatedText = data.length > maxTextLength ? data.substring(0, maxTextLength) + '...' : data;

            // return truncatedText;
            return data;
        };

        const subfamilyArticuloRender = function (data, type, full, meta) {
            // let maxTextLength = vw > 768 ? 25 : 50;
            // let truncatedText = data.length > maxTextLength ? data.substring(0, maxTextLength) + '...' : data;

            // return truncatedText;

            return data;
        };

        const exportColumns = [0, 1, 2, 3, 4, 5, 6, 7];
        const exportOptions = {
            columns: exportColumns,
            format: {
                body: function (data, row, column) {
                    if (column === 1) {
                        return $('<div>').html(data).text().trim();
                    }

                    if (column === 4) {
                        if (typeof data === 'string') {
                            if (data.includes('type-available')) return 'Disponible';
                            if (data.includes('type-under-order')) return 'Bajo pedido';
                            if (data.includes('type-not-available')) return 'No disponible';
                        }
                        return '';
                    }

                    return $('<div>').html(data).text().trim();
                }
            }
        };

        let tableRatesPublic = $('#tblRatesPublic').DataTable({
            sort: true,
            order: [[0, 'asc']],
            layout: {
                topStart: {
                    buttons: [
                        {
                            extend: 'copy',
                            exportOptions: exportOptions,
                        },
                        {
                            extend: 'excel',
                            exportOptions: exportOptions,
                        },
                        {
                            extend: 'pdf',
                            exportOptions: exportOptions,
                        },
                        'colvis'
                    ]
                }
            },
            serverSide: true,
            processing: true,
            stateSave: true,
            paging          : true,
            pagingTypeSince : 'numbers',
            pagingType      : 'full_numbers',
            responsive      : true,
            pagingType      : typePagination,
            "language": {
                processing: '<div id="butterfly-container" style="z-index: 9999"><svg id="butterfly" viewBox="0 0 42 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="left-wing" d="M2.03493 6.16004C-2.29627 8.91945 1.66597 21.835 4.93727 25.9729C8.47692 30.4454 15.9385 28.0943 15.9385 28.0943C9.45628 26.3566 4.10324 22.8277 7.01233 17.3291C8.64684 14.2373 11.3323 11.0831 14.6662 8.3283C14.6662 8.3283 5.99268 3.64164 2.03493 6.16004" fill="#B7C72F"/><path id="right-wing" d="M35.163 0.000616372C38.3895 -0.0373051 43.3177 1.65577 41.6139 10.2975C39.9078 18.9391 38.157 29.189 25.993 29.3719C17.2837 29.5035 2.58629 25.6958 7.01136 17.3285C11.4342 8.96346 23.5982 0.13894 35.163 0.000616372Z" fill="#289643"/></svg></div><span class="sr-only">Loading...</span>'
            },
            ajax: {
                "type": "GET",
                 "url": "/api/v1/rates-public",
            },
            lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
            autoWidth: false,
            columns: [
                { data: 'codigoArticulo', name: "codigoArticulo", className: 'text-break' },
                {
                    data: 'descripcionArticulo',
                    name: "descripcionArticulo",
                    className: 'description details-control', //details-control para dar clic
                    render: descripcionArticuloRender,
                    width: '30%'
                },
                { 
                    data: 'codigoFamilia', 
                    name: "codigoFamilia",
                    render: familyArticuloRender,
                    orderable: false,
                    width: '15%'
                },
                { 
                    data: 'codigoSubfamilia', 
                    name: "codigoSubfamilia",
                    render: subfamilyArticuloRender,
                    orderable: false,
                    width: '12%'
                },
                {
                    data: 'availability',
                    name: "availability",
                    className: 'text-center',
                    render: availabilityRender,
                },
                {
                    data: 'unidadesMinimas',
                    name: "unidadesMinimas",
                    className: 'text-center',
                    orderable: false,
                    defaultContent: '',
                },
                {
                    data: 'unidadesVenta',
                    name: "unidadesVenta",
                    className: 'text-center',
                    orderable: false,
                    defaultContent: '',
                },
                { data: 'pvp', name: "pvp", className: 'text-end' },
            ],
        });

        tableRatesPublic.on('responsive-resize', function (e, datatable, columns) {
            var count = columns.reduce(function (a, b) {
                return b === false ? a + 1 : a;
            }, 0);
         
            console.log(count + ' column(s) are hidden');
            if (count == 0) {
                addSearchBox();
            }
        });

        $('#tblRatesPublic tbody').on('click', 'td.details-control', function () {
            let tr = $(this).closest('tr');
            let row = tableRatesPublic.row(tr);
            let icon = tr.find('i.iconChange');

            if (row.child.isShown()) {
                row.child.hide();
                tr.removeClass('shown');
                icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
            } else {
                row.child(row.data().information).show();
                tr.addClass('shown');
                icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
            }
        });
    }

});